
import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaWhatsapp, FaAccessibleIcon, FaUtensils, FaUserFriends, FaMusic, FaTree, FaSwimmer } from 'react-icons/fa';
import Gallery from '../components/Gallery';
import SEO from '../components/SEO';
import { sedePorSlug } from '../data/organizacion';
import { breadcrumb, paginaDeSede } from '../data/schema';
import temperley_frente from '../assets/img/Temperley_Frente.webp'
import Temp_G1 from '../assets/img/temperley/Temp_G1.png'
import Temp_G2 from '../assets/img/temperley/Temp_G2.png'
import Temp_G3 from '../assets/img/temperley/Temp_G3.png'
import Temp_arte from '../assets/img/temperley/temp_arte3.jpeg'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/7KnDCOiB6qIcEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const Temperley = () => {
  const sede = sedePorSlug('temperley');

  // Imágenes para la galería (en producción se reemplazarían por imágenes reales)
  const galleryImages = [
    { src: Temp_G1, alt: 'CET Temperley - Atencion a niños y jóvenes con discapacidad' },
    { src: Temp_arte, alt: 'CD Temperley - Taller de arte para personas con discapacidad' },
    { src: Temp_G2, alt: 'Centro Educativo Terapéutico Temperley - Terapias individuales' },
    { src: Temp_G3, alt: 'Centro de Dia Temperley - Kinesiología, Fisioterapia, Psicología, Psiquiatría, Fonoaudiología, Psicopedagogía, Educación Especial' }
  ];

  return (
    <div className="container">
      <SEO
        title="Sede Temperley — Mi Lugar CET y Centro de Día"
        description={`Sede Temperley de Mi Lugar, en ${sede.direccionCompleta}. CET y Centro de Día con instalaciones adaptadas y equipo interdisciplinario para familias de ${sede.zonas.join(', ')}.`}
        path="/temperley"
        image="/images/temperley.jpg"
        jsonLd={[
          breadcrumb([{ nombre: 'Sede Temperley', path: '/temperley' }]),
          paginaDeSede(sede),
        ]}
      />
      <div className="sede-header">
        <h1>Sede Temperley</h1>
        <p>Conoce nuestra sede principal, un espacio diseñado para el desarrollo integral y bienestar de nuestros concurrentes.</p>
      </div>

      <section className="sede-info">
        <div className="sede-details">
          <h2>Sobre nuestra sede</h2>
          <p>Nuestra sede de Temperley fue la primera instalación de Mi Lugar, inaugurada en 1982 por la Lic. Mirtha Wechsung. Ubicada en una zona tranquila y accesible, cuenta con amplias instalaciones especialmente adaptadas para brindar la mejor atención a nuestros concurrentes.</p>
          <p>Disponemos de salas terapéuticas equipadas, espacios recreativos, comedor, áreas verdes y todo lo necesario para desarrollar nuestras actividades en un ambiente seguro y estimulante.</p>

          <div className="sede-contact">
            <h3>Información de contacto</h3>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>A. Gallardo 646, Temperley - Provincia de Buenos Aires</span>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>1165651675</span>
            </div>
          </div>

          <div className="sede-buttons" style={{ marginTop: '20px' }}>
            <a href={sede.whatsapp} className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>

        <div className="sede-image">
          <img src= {temperley_frente} alt="Sede Temperley" />
        </div>
      </section>

      <section className="sede-facilities">
        <h2 className="section-title">Nuestras instalaciones</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaAccessibleIcon className="facility-icon" />
            <div>
              <h3>Accesibilidad total</h3>
              <p>Instalaciones adaptadas para movilidad reducida</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUtensils className="facility-icon" />
            <div>
              <h3>Comedor</h3>
              <p>Servicio de alimentación supervisado</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUserFriends className="facility-icon" />
            <div>
              <h3>Salas terapéuticas</h3>
              <p>Espacios especializados para cada terapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaMusic className="facility-icon" />
            <div>
              <h3>Sala de música</h3>
              <p>Equipada para musicoterapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaTree className="facility-icon" />
            <div>
              <h3>Espacios verdes</h3>
              <p>Áreas al aire libre para actividades recreativas</p>
            </div>
          </div>
          <div className="facility-item">
            <FaSwimmer className="facility-icon" />
            <div>
              <h3>Actividades acuáticas</h3>
              <p>Programa de hidroterapia</p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Galería de fotos</h2>
        <Gallery images={galleryImages} />
      </section>

      <section className="map-container">
        <h2 className="section-title">¿Cómo llegar?</h2>
        <p>Estamos ubicados en A. Gallardo 646, Temperley, Provincia de Buenos Aires.</p>
        <div style={{ marginTop: '20px' }}>
          <a 
            href="https://www.google.com/maps/search/?api=1&query=A.+Gallardo+646,+Temperley,+Buenos+Aires" 
            className="btn"
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FaMapMarkerAlt /> Ver en Google Maps
          </a>
        </div>
        <div style={{ marginTop: '30px', height: '400px' }}>
          <iframe 
            src="https://maps.google.com/maps?q=A.+Gallardo+646,+Temperley,+Buenos+Aires&hl=es&z=16&output=embed"
            width="100%" 
            height="100%" 
            style={{ border: 0, borderRadius: '8px' }} 
            allowFullScreen="" 
            loading="lazy"
            title="Mapa Sede Temperley"
          ></iframe>
        </div>
        <p>Atendemos a niños y jóvenes con discapacidad de Temperley, Lomas de Zamora, Lanus, Monte Grande, Banfield, Turdera, Barrio La Perla, San Jose y Rafael calzada</p>
      </section>

       {/* WhatsApp Float Button With Report*/}
      <a
        href={sede.whatsapp}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escribinos por WhatsApp"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion(sede.whatsapp);
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Temperley;
